import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cadef8b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "path" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_list" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "box_achieve" }
const _hoisted_7 = { class: "box_award" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 开发者成长路径 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(" 我们从开发者的需求出发来运营社区，帮助其快速成长。 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_row, { class: "title" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createTextVNode(" 级别 ")
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, { span: 9 }, {
              default: _withCtx(() => [
                _createTextVNode(" 如何达成 ")
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, { span: 9 }, {
              default: _withCtx(() => [
                _createTextVNode(" 奖励 ")
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_row, { class: "item" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: 24,
                md: 6
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_typography_title, { level: 5 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title) + " ", 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString(item.title_en), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((index+1), (v) => {
                        return (_openBlock(), _createElementBlock("i"))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */),
              _createVNode(_component_a_col, {
                xs: 24,
                md: 18
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (v) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_a_typography_title, { level: 5 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 如何达成 ")
                          ]),
                          _: 1 /* STABLE */
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.achieve, (vv) => {
                          return (_openBlock(), _createElementBlock("p", {
                            class: _normalizeClass({active:vv.includes('个被合并的 PR')})
                          }, _toDisplayString(vv), 3 /* TEXT, CLASS */))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_a_typography_title, { level: 5 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 奖励 ")
                          ]),
                          _: 1 /* STABLE */
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.award, (vv) => {
                          return (_openBlock(), _createElementBlock("div", null, [
                            _createElementVNode("i", {
                              class: _normalizeClass(`i_${vv.icon}`)
                            }, null, 2 /* CLASS */),
                            _createTextVNode(" " + _toDisplayString(vv.name), 1 /* TEXT */)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ]))
}